import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LeadGen from '@cont/LeadGen/getStarted/LeadGen';
import getLeadGen from '@cms/api';
import Header from '@layout/HeaderTemplates/Base';

const Container = styled.div``;

const GetStarted = ({ apiResponse }) => {
  return (
    <>
      <NextSeo title="Book a Class" description="Best in class CBSE learning" />
      <Header />
      <LeadGen apiResponse={JSON.parse(apiResponse)} />
    </>
  );
};

GetStarted.getInitialProps = async () => {
  const apiResponse = await getLeadGen('api/lead-gens/cbse-class-6-12/');
  return {
    apiResponse: JSON.stringify(apiResponse)
  };
};

GetStarted.Layout = ({ children }) => <Container>{children}</Container>;
GetStarted.Layout.displayName = 'GetStarted';

GetStarted.propTypes = {
  apiResponse: PropTypes.string.isRequired
};

GetStarted.Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default GetStarted;
